<sfx-toolbar enableDivider>
    <span translate>Support</span>
</sfx-toolbar>
<sfx-content>
    <sfx-header disableDividers disableBackground>
        <span>Knowledge base</span>
    </sfx-header>
    <sfx-section disableContentPadding>
        <div class="accent">
            <span translate>Have a question about the product? Read advice and answers from the Salesflare team.</span>
            <p>
                <a class="icon-link" [href]="'https://howto.salesflare.com' | howtoUrl" target="_blank" rel="noopener"> <mat-icon fontSet="salesflare" fontIcon="sf-icon-description" class="icon-18 button"></mat-icon><span translate>Check the knowledge base</span></a>
            </p>
        </div>
    </sfx-section>
    <sfx-header disableDividers disableBackground translate>
        <span translate>API Docs</span>
    </sfx-header>
    <sfx-section disableContentPadding>
        <div class="accent">
            <span translate>Developing on top of Salesflare? Read our API Docs.</span>
            <p>
                <a class="icon-link" href="https://api.salesflare.com/docs" target="_blank" rel="noopener"> <mat-icon fontSet="salesflare" fontIcon="sf-icon-settings" class="icon-18 button"></mat-icon><span translate>Check the API Docs</span></a>
            </p>
        </div>
    </sfx-section>
    <sfx-header disableDividers disableBackground>
        <span translate>Contact Us</span>
    </sfx-header>
    <sfx-section disableContentPadding>
        <div class="accent">
            <span translate>Can't find what you're looking for?</span>
            <p>
                <a class="icon-link" id="intercom-chat-button" href="mailto: support@salesflare.com"> <mat-icon fontSet="salesflare" fontIcon="sf-icon-support" class="icon-18 button"></mat-icon><span translate>Have a chat</span></a>
            </p>
            <p>
                <a class="icon-link" href="https://salesfla.re/talk-to-support" target="_blank" rel="noopener"> <mat-icon fontSet="salesflare" fontIcon="sf-icon-conf-call" class="icon-18 button"></mat-icon><span translate>Book a video call</span></a>
            </p>
            <p>
                <a class="icon-link" (click)="mailTo('support@salesflare.com', $event)"> <mat-icon fontSet="salesflare" fontIcon="sf-icon-email" class="icon-18 button"></mat-icon><span translate>Email support&#64;salesflare.com</span></a>
            </p>
        </div>
    </sfx-section>
</sfx-content>